import React, { Component, Fragment } from 'react';

class ApplicationSettingDisplay extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { applicationSettingsData, ApplicationVerificationStatusText } = this.props;
        const { schoolList, status, name, email, phone, isEmail, isSms, startDate, endDate, samplingType, followupFrequency } = (applicationSettingsData || {});
        return (
            <Fragment>
                <div className='row'>
                    <div className='col-md-12 sectionTitle text-center'>
                        <h2>Application Verification Settings</h2>
                    </div>
                    <div className='col-md-12'>
                        <div className='row form-group'>
                            <div className='col-md-12 text-right'>
                                <label>Application Verification Status</label> : <label style={{ fontSize: '25px' }} className='color-1'>{((ApplicationVerificationStatusText || {})[(status || '').toUpperCase()] || {}).text || ApplicationVerificationStatusText.PREPARE}</label>
                            </div>
                        </div>
                        <div className='row form-group'>
                            <div className='col-md-6'>
                                <label>Verification Start Date</label> : <label className='color-4'>{startDate || ''}</label>
                            </div>
                            <div className='col-md-6'>
                                <label>Verification End Date</label> : <label className='color-4'>{endDate || ''}</label>
                            </div>
                        </div>
                        <div className='row form-group'>
                            <div className='col-md-6'>
                                <label>Sampling Type</label> : <label className='color-4'>{samplingType}</label>
                            </div>
                            {/* <div className='col-md-6'>
                                <label>Follow-up Frequency</label> : <label className='color-4'>{followupFrequency}</label>
                            </div> */}
                        </div>
                        <div className='row form-group'>
                            <div className='col-md-6'>
                                <label>Follow-up Communication Type</label> : {isEmail && <label style={{ marginRight: '10px' }} className='color-4'>{'Email'}</label>}  {isSms && <label className='color-4'>{'SMS'}</label>}
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-6' >
                                <div >
                                    <label>Verification Contact Details</label>
                                </div>
                                <div style={{ marginLeft: '20px' }}>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <label>Name</label> : <label className='color-4'>{name}</label>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <label>Email</label> : <label className='color-4'>{email}</label>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <label>Phone:</label> : <label className='color-4'>{phone}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <label>Selected Schools :</label>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <ul style={{ marginLeft: '10px' }}>
                                            {
                                                schoolList.filter(s => s.selected).map(sch => {
                                                    return <li><label>{sch.schoolName}</label></li>
                                                })

                                            }</ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        );
    }
}

export default ApplicationSettingDisplay;


// WEBPACK FOOTER //
// ./src/components/District/applicationVerification/applicationSettingDisplay.js